import { useState } from 'react'

import Loading from '../../shared/Loading'

import FormLogin from './FormLogin'
import ModalFormRecover from './ModalFormRecover'
import ModalSignContract from './ModalSignContract'

function CardLogin(props) {
  const [loadingActive, setLoadingActive] = useState(false)
  const [recoverModalActive, setRecoverModalActive] = useState(false)
  const [signContractModalActive, setSignContractModalActive] = useState(false)
  const [contractDocs, setContractDocs] = useState([])

  return (
    <>
      <FormLogin
        active={props.active}
        onHandleSetCardLogin={props.onHandleSetCardLogin}
        setRecoverModalActive={setRecoverModalActive}
        setSignContractModalActive={setSignContractModalActive}
        setContractDocs={setContractDocs}
        setLoadingActive={setLoadingActive}
      />

      <ModalFormRecover
        active={recoverModalActive}
        setRecoverModalActive={setRecoverModalActive}
        setLoadingActive={setLoadingActive}
      />

      <ModalSignContract
        active={signContractModalActive}
        contractDocs={contractDocs}
        setSignContractModalActive={setSignContractModalActive}
        setLoadingActive={setLoadingActive}
      />

      <Loading active={loadingActive} dataCy='loading' />
    </>
  )
}

export default CardLogin
